<template>
    <div class="content" :class="visible ? 'content--visible' : ''">
        <h2>How we stack up</h2>
        <p>
            <strong>When postcodes are ranked by CBD peak travel time, the overall accessibility profile of Melbourne can be observed.</strong>
        </p>
        <p>Here, 75% of observed postcodes have an above 30 minute commute time, while it takes 30% of postcodes more than an hour to make it into the CBD via public transport.</p>
        <p>As further transport infrastructure comes online in the coming years, we can expect this profile to transform.</p>
        <p>Beyond this, the arrival of new mobility technologies such as connected and autonomous vehicles as well as autonomous VTOL passenger aircraft in the coming years will undoubtedly revolutionise accessibility.</p>
        <p>Select a single postcode to follow through the journey.</p>
        <multiselect
            class="postcode__selector"
            :value="selectedPostcode"
            :options="data"
            track-by="postcode"
            label="label"
            @input="update_selected_postcode"
        ></multiselect>
    </div>
</template>

<script>
import tooltip_mixin from "@/assets/tooltip_mixin";

export default {
    props: {
        visible: {
            default: () => false
        }
    },
    mixins: [tooltip_mixin]
};
</script>

<style scoped>
.postcode__selector {
    width: 80%;
}
</style>
